import { getApiHostName } from '../utils/get-api-host-name';
export var feedbackProdConfig = {
    FEEDBACK_SERVICE_BASE_URL: "https://media-feedback." + getApiHostName() + "/_api/feedback",
};
export var feedbackDebugConfig = {
    FEEDBACK_SERVICE_BASE_URL: "https://media-feedback-test." + getApiHostName() + "/_api/feedback",
};
//# sourceMappingURL=feedback-config.constants.js.map